<div class="chatbot-container">
  <!-- Initial State - Centered Input -->
  <div
    *ngIf="questionnaireTurns.length === 0 && !isLoading"
    class="initial-state"
  >
    <div class="initial-input-container">
      <div class="initial-input-wrapper">
        <input
          type="text"
          class="initial-input"
          [(ngModel)]="userInput"
          (keydown)="onKeydown($event)"
          placeholder="What story would you like to create?"
        />
        <button
          class="start-button"
          (click)="sendMessage()"
          [disabled]="!userInput.trim()"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path d="M12 19V5M5 12l7-7 7 7" />
          </svg>
        </button>
      </div>
      <!-- <button class="idk-button" (click)="onIdontKnow()">I don't know</button> -->
    </div>
  </div>

  <!-- Chat Section - shown after conversation starts -->
  <div *ngIf="questionnaireTurns.length > 0 || isLoading" class="chat-section">
    <div class="chat-header">
      <h3>Story Assistant</h3>
    </div>

    <!-- Messages Area -->
    <div class="messages-container" #messagesContainer>
      <ng-container *ngFor="let turn of questionnaireTurns; let i = index">
        <!-- User's answer (if any) -->
        <div *ngIf="turn.answer" class="message user-message">
          <div class="message-bubble">
            <span class="message-label">You</span>
            <p>{{ turn.answer }}</p>
          </div>
        </div>
        <!-- Chatbot's text -->
        <div *ngIf="turn.text" class="message chatbot-message">
          <div class="message-bubble">
            <span class="message-label">Assistant</span>
            <p>{{ turn.text }}</p>
          </div>
        </div>
      </ng-container>

      <!-- Typing Indicator -->
      <div *ngIf="isLoading" class="message chatbot-message">
        <div class="message-bubble typing-indicator">
          <span class="dot"></span>
          <span class="dot"></span>
          <span class="dot"></span>
          <span class="typing-text">Thinking...</span>
        </div>
      </div>

      <!-- Questions Section - Directly under chatbot message -->
      <div *ngIf="currentQuestions.length > 0" class="questions-section">
        <div class="questions-grid">
          <div
            *ngFor="let question of currentQuestions; let qIndex = index"
            class="question-card"
          >
            <p class="question-text">{{ question.text }}</p>

            <!-- Options in a column -->
            <div class="options-list">
              <button
                *ngFor="let option of question.options"
                class="option-button"
                [class.selected]="isOptionSelected(question, option)"
                (click)="selectOption(question, option)"
              >
                {{ option }}
              </button>
            </div>
          </div>
        </div>

        <!-- Submit Answers Button -->
        <div class="submit-answers-area">
          <button
            class="submit-answers-button"
            (click)="submitAnswers()"
            [disabled]="isLoading || !canSubmitAnswers()"
          >
            <span *ngIf="isLoading" class="spinner"></span>
            <ng-container *ngIf="!isLoading">Continue</ng-container>
          </button>
        </div>
      </div>
    </div>

    <!-- Input Area (shown when no questions and conversation has started) -->
    <div *ngIf="currentQuestions.length === 0" class="input-area">
      <input
        type="text"
        class="message-input"
        [(ngModel)]="userInput"
        (keydown)="onKeydown($event)"
        placeholder="Type your message..."
        [disabled]="isLoading || conversationAborted"
      />
      <button
        class="send-button"
        (click)="sendMessage()"
        [disabled]="isLoading || !userInput.trim() || conversationAborted"
      >
        <span *ngIf="isLoading" class="spinner"></span>
        <ng-container *ngIf="!isLoading">Send</ng-container>
      </button>
    </div>

    <div *ngIf="conversationAborted" class="aborted-notice">
      <p>The conversation has ended. Please start a new session if needed.</p>
    </div>
  </div>

  <!-- Video Structure Section -->
  <div *ngIf="videoStructure" class="structure-section">
    <h3>Your Video Structure</h3>

    <div
      *ngFor="let section of videoStructure; let sectionIndex = index"
      class="video-section-card"
    >
      <h4 class="section-type">{{ formatSectionType(section.title) }}</h4>

      <div *ngIf="section.text" class="section-text">
        <strong>Narration:</strong>
        <p>{{ section.description }}</p>
      </div>

      <!-- Videos List -->
      <div *ngIf="section.videos?.length > 0" class="media-list">
        <h5>Videos</h5>
        <div
          *ngFor="let video of section.videos; let videoIndex = index"
          class="media-item"
        >
          <span class="media-description">{{ video }}</span>
          <button
            class="upload-button"
            (click)="onUploadVideo(section, videoIndex)"
          >
            Upload Video
          </button>
        </div>
      </div>

      <!-- Images List -->
      <div *ngIf="section.images?.length > 0" class="media-list">
        <h5>Images</h5>
        <div
          *ngFor="let image of section.images; let imageIndex = index"
          class="media-item"
        >
          <span class="media-description">{{ image }}</span>
          <button
            class="upload-button"
            (click)="onUploadImage(section, imageIndex)"
          >
            Upload Image
          </button>
        </div>
      </div>
    </div>
  </div>
  <app-video-questionnaire></app-video-questionnaire>
</div>
